import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  PanelHeader,
  PanelBody,
  ParticipantRow,
  ParticipantRowHeader,
  ParticipantRowName,
  ParticipantRowStatus,
  ParticipantStatusLabel,
  ParticipantStatusIcons,
  ChatPlaceholder,
} from './style';
import ParticipantStatusBadges from '../ParticipantStatusBadges';

const StagePanels = ({ showParticipants, showChat, users }) => {
  const { t } = useTranslation();

  return (
  <>
    {showParticipants ? (
      <div className="panel">
        <PanelHeader>{t('Common.UI.participants')}</PanelHeader>
        <PanelBody>
          {(users || []).map((user) => (
            <ParticipantRow key={user.attendeeId || user.externalUserId || user.participantId || user.id || user.name} $self={Boolean(user.self)}>
              <ParticipantRowHeader>
                <ParticipantRowName>{user.fullName || user.name || t('VideoChatV2.participant')}{user.self ? ` (${t('VideoChatV2.you')})` : ''}</ParticipantRowName>
                <ParticipantRowStatus>
                  <ParticipantStatusLabel>{user.joined ? t('VideoChatV2.joined') : t('VideoChatV2.notInMeeting')}</ParticipantStatusLabel>
                  {user.joined ? (
                    <ParticipantStatusIcons>
                      <ParticipantStatusBadges
                        attendeeId={user.attendeeId}
                        joined={user.joined}
                        iconOnly
                        showLabels={false}
                        providedMuted={user.muted}
                        providedVideoEnabled={user.cameraOn}
                        preferProvidedStatus={Boolean(user.self)}
                      />
                    </ParticipantStatusIcons>
                  ) : null}
                </ParticipantRowStatus>
              </ParticipantRowHeader>
            </ParticipantRow>
          ))}
        </PanelBody>
      </div>
    ) : null}

    {showChat ? (
      <div className="panel">
        <PanelHeader>{t('Common.Messaging.messages')}</PanelHeader>
        <ChatPlaceholder>
          {t('VideoChatV2.chatPlaceholder')}
        </ChatPlaceholder>
      </div>
    ) : null}
  </>
  );
};

export default StagePanels;
